import React, { useEffect } from 'react';
import { ValidateEmail } from './fields/ValidateEmail/ValidateEmail';
import MessageBox from 'components/commons/MessageBox/MessageBox';
import { formatText } from 'core/i18n';
import { doTagOTPExceededAttemps } from './sections/EmailOTPValidation/tagging';

export const EmailValidation = ({
    emailInputRef,
    dispatch,
    formActions,
    sendEmailOTP,
    shouldShowInvalidatedEmailMessage,
    readyCaptchaToken,
    userProfile,
    userProfileForm,
}) => {
    useEffect(() => {
        shouldShowInvalidatedEmailMessage && doTagOTPExceededAttemps();
    }, [shouldShowInvalidatedEmailMessage]);

    return (
        <div className="validate-email">
            {shouldShowInvalidatedEmailMessage && (
                <MessageBox
                    contentText={formatText('otpEmailValidation-tooManyAttempts')}
                    boxColor="red"
                    iconColor="alert-red"
                />
            )}
            <ValidateEmail
                ref={emailInputRef}
                dispatch={dispatch}
                formActions={formActions}
                readyCaptchaToken={readyCaptchaToken}
                sendEmailOTP={sendEmailOTP}
                userProfile={userProfile}
                userProfileForm={userProfileForm}
            />
        </div>
    );
};
